import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import axios from 'axios';
import store from './store';
import * as VueGoogleMaps from 'vue2-google-maps'
import VueClipboard from 'vue-clipboard2'
 
var SocialSharing = require('vue-social-sharing');
Vue.use(SocialSharing);

Vue.use(VueClipboard)
window.axios = require('axios');

require('../public/css/app.css')

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAPAPAdZqnMuHHWWNtHcyBtBWdkemfosDU',
    libraries: 'places'
  },
})

axios.interceptors.request.use(function (config) {
  if (config.url.startsWith('https://web-admin.sum.ba')){
    config.headers.accept = "application/json";
    config.headers.language = 'hr';
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});

import 'material-design-icons-iconfont/dist/material-design-icons.css'

import vuetify from '@/plugins/vuetify'
import 'babel-polyfill'

// Google analytics
// import VueGtag from "vue-gtag";

// Vue.use(VueGtag, {
//     config: { id: "UA-141666267-3" }
// }, router);

// Axios
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['Accept'] = 'application/json';

import { apiDomain } from './.env.js'

window.skoleApi = axios.create({
    baseURL: apiDomain + 'api',
    timeout: 5000,
    withCredentials: true
});

// Moment
import VueMoment from 'vue-moment'

import moment from 'moment';
moment.locale('hr');

Vue.use(VueMoment, {moment});

// SUM TV
import {eronetPlayer} from './.env.js'

Vue.prototype.getEronetEmbed = function(path) {
    if (!path)
        return false;

    if (path.includes('.mp4')) {
        let ext = path.indexOf('.mp4');
        path = path.substring(0, ext)
    }

    return eronetPlayer + path;
};

Vue.config.productionTip = false;

new Vue({
	router,
	vuetify,
  iconfont: 'md',
  store,
	render: h => h(App)
}).$mount('#app');
